import React from 'react';
import { useSelector } from 'react-redux';
import { Grid, ThemeProvider, StyledEngineProvider } from '@mui/material';

import theme from 'styles/theme_dark';
import FileCard from './FileCard';

const FileGrid = ({ selectActions = [] }) => {
    const files = useSelector((state) => state.files.files);

    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme}>
                <Grid container spacing={4}>
                    {files.map((file) => (
                        <FileCard file={file} key={file.file_id} selectActions={selectActions} />
                    ))}
                </Grid>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default FileGrid;
